import pay from './pay';
import insure from './insure';
import refund from './refund';

export default {
  pay,
  insure,
  refund,
};
